// extracted by mini-css-extract-plugin
export default {"center_page":"ErrorPage_center_page__lGbin","error_heading":"ErrorPage_error_heading__bBN2l","error_info":"ErrorPage_error_info__P8tc5"};